import {
  WIDTHS
} from 'lib/constants.js';

const IMG_PREVIEW_WIDTH = WIDTHS.IMG_PREVIEW_WIDTH;

export const dataURItoBlob = (dataURI) => {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
      byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], {type:mimeString});
};

export const getRotatedImageBlob = (original, fileType, rotation) => {
  return dataURItoBlob(getRotatedImageDataURL(original, fileType, rotation).dataURL);
};

export const downloadCrossOriginImage = async url => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = e => {
      resolve(img);
    };
    img.crossOrigin = 'anonymous';
    img.src = `${url}?v=${Math.random()}`;
  });
};

export const downloadCrossOriginImageBlob = async (url, fileType) => {
  const imageElement = await downloadCrossOriginImage(url);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = imageElement.width;
  canvas.height = imageElement.height;
  ctx.drawImage(imageElement, 0, 0, imageElement.width, imageElement.height);
  let dataURL;
  if (fileType == 'image/jpeg') {
    dataURL = canvas.toDataURL("image/jpeg", 1.0);
  } else {
    dataURL = canvas.toDataURL("image/png");
  }
  return dataURItoBlob(dataURL);
};

export const getRotatedImageDataURL = (original, fileType, rotation) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (rotation == 90 || rotation == 270) {
    canvas.width = original.height;
    canvas.height = original.width;
  } else {
    canvas.width = original.width;
    canvas.height = original.height;
  }

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  if (rotation == 90 || rotation == 270) {
    ctx.translate(original.height / 2, original.width / 2);
  } else {
    ctx.translate(original.width / 2, original.height / 2);
  }
  ctx.rotate(rotation * Math.PI / 180);
  ctx.drawImage(original, -original.width / 2, -original.height / 2);

  let dataURL;
  if (fileType == 'image/jpeg') {
    dataURL = canvas.toDataURL("image/jpeg", 1.0);
  } else {
    dataURL = canvas.toDataURL("image/png");
  }
  return { dataURL, width: canvas.width, height: canvas.height };
};

export const getScaledImageDataURL = (original, fileType) => {
  const canvas = document.createElement("canvas");
  const maxDimension = Math.max(original.width, original.height);
  const ratio = original.height / original.width;

  let height;
  let width;

  if (maxDimension > IMG_PREVIEW_WIDTH) {
    if (original.width > original.height) {
      width = IMG_PREVIEW_WIDTH;
      height = IMG_PREVIEW_WIDTH * ratio;
    } else {
      height = IMG_PREVIEW_WIDTH;
      width = IMG_PREVIEW_WIDTH / ratio;
    }
  } else {
    width = original.width;
    height = original.height;
  }

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(original, 0, 0, canvas.width, canvas.height);
  let dataURL;
  if (fileType == 'image/jpeg') {
    dataURL = canvas.toDataURL("image/jpeg", 0.9);
  } else {
    dataURL = canvas.toDataURL("image/png");
  }
  return dataURL;
};

export const getScaledImageBlob = (original, fileType) => {
  const image = dataURItoBlob(getScaledImageDataURL(original, fileType));
  return image;
};

export const sendFileToAmazon = ({ url, file, onSuccess, onFailure }) => {
  $.ajax({
    type: 'PUT',
    url,
    data: file,
    processData: false,
    headers: {
      'x-amx-acl': 'public-read',
      'Cache-Control': 'max-age=2592000',
    },
    contentType: file.type,
    success: onSuccess,
    error: onFailure,
  });
};



// WEBPACK FOOTER //
// ./starling/src/lib/files.js